// extracted by mini-css-extract-plugin
module.exports = {"item":"QuoteTermsRowItem_item__3kABY"};